module.exports = __webpack_public_path__ + "assets/img/C4.0fd46502.jpg";